/**
 * Naira valuation for a crypto deposit.
 *
 * ⚠️ Behaviour change — please verify against the backend.
 *
 * The codebase previously had two contradictory formulas for the same figure:
 *
 *   • PaymentDeets.tsx / ActivityTable.tsx   → usdtAmount * usdtRate   ✅
 *   • PaymentDeetTable.tsx / SinglePaymentModal.tsx → amount * usdtRate ❌
 *
 * The second multiplies a *raw crypto quantity* (0.01 BTC, 2.5 ETH…) by the
 * USDT→NGN rate, which is only correct when the deposit currency happens to be
 * USDT. For a BTC deposit it under-reports by orders of magnitude.
 *
 * Everything now uses the first formula. `usdtAmount` is the USD-equivalent the
 * backend already computed, and the "usdt" entry in `rates` is USDT→NGN.
 */
export const getUsdtRate = (deposit: any): number =>
  deposit?.rates?.find(
    (rate: { abbr?: string }) => rate?.abbr?.toLowerCase() === "usdt"
  )?.rate ?? 0;

export const depositNairaValue = (deposit: any): number =>
  (deposit?.usdtAmount ?? 0) * getUsdtRate(deposit);
